module.exports = __webpack_public_path__ + "img/user_profile.d9682a5a.png";